module.exports = __webpack_public_path__ + "img/thumb_The Canyon.024886d7.jpg";